// import { Button, Flex, Form, Input, message, Switch, TreeSelect } from "antd";
// import { useEffect, useState } from "react";
// import { fetchOrganization } from "../../Organization/Service/organization";

// const RoleForm = (props) => {
//   const [selectedFirm, setSelectedFirm] = useState(null);
//   const [firmList, setFirmList] = useState([]);
//   const [firmLoading, setFirmLoading] = useState(false);
//   const [form] = Form.useForm();
//   const [messageApi, contextHolder] = message.useMessage();

//   const fetchFirmList = async () => {
//     setFirmLoading(true);
//     try {
//       const res = await fetchOrganization(); // replace with your firm API
//       setFirmList(res.data?.data || []);
//     } catch (err) {
//       messageApi.open({ type: "error", content: "Error fetching firm list" });
//     } finally {
//       setFirmLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (props.editData) {
//       form.setFieldsValue({
//         category: props.editData.category,
//       });
//     } else {
//       form.resetFields();
//     }
//     fetchFirmList();
//   }, [props.editData, form]);

//   return (
//     <Form
//       form={form}
//       layout="horizontal"
//       labelCol={{ span: 6 }}
//       wrapperCol={{ span: 18 }}
//       style={{ maxWidth: 600 }}
//       onFinish={(data) =>
//         props.saveData({ ...props.editData, ...data }).then((success) => {
//           if (success) {
//             form.resetFields();
//           }
//         })
//       }
//     >
//       {contextHolder}
//       <Form.Item
//         label="Role"
//         name="roleName"
//         rules={[{ required: true, message: "Please input role name!" }]}
//       >
//         <Input />
//       </Form.Item>
//       <Form.Item
//         label="Organization"
//         name={["firm", "uuid"]}
//         rules={[{ required: true, message: "Please select a organization" }]}
//       >
//         <TreeSelect
//           placeholder="Select Organization"
//           disabled={props.mode === "view"}
//           value={selectedFirm?.uuid}
//           style={{ width: 300 }}
//           loading={firmLoading}
//           treeData={firmList.map((f) => ({
//             title: f.name,
//             value: f.uuid,
//             key: f.uuid,
//           }))}
//           onChange={(uuid) => {
//             const firm = firmList.find((f) => f.uuid === uuid);
//             setSelectedFirm(firm ? { firm: firm.name, uuid: firm.uuid } : null);
//           }}
//           treeDefaultExpandAll
//         />
//       </Form.Item>
//       <Form.Item label="Status" name="active" valuePropName="checked">
//         <Switch
//           disabled={props.mode === "view"}
//           defaultChecked
//           checkedChildren="Active"
//           unCheckedChildren="Inactive"
//         />
//       </Form.Item>

//       <Flex justify="end">
//         <Button type="primary" htmlType="submit">
//           Submit
//         </Button>
//       </Flex>
//     </Form>
//   );
// };

// export default RoleForm;

import {
  Button,
  Flex,
  Form,
  Input,
  message,
  Switch,
  TreeSelect,
  Spin,
} from "antd";
import { useEffect, useState } from "react";
import { fetchOrganization } from "../../Organization/Service/organization";

// --- Utility: Build hierarchical organization tree ---
const buildTreeFromData = (data) => {
  const map = {};
  const tree = [];

  data.forEach((item) => {
    map[item.uuid] = { ...item, children: [] };
  });

  data.forEach((item) => {
    if (item.parent?.uuid && map[item.parent.uuid]) {
      map[item.parent.uuid].children.push(map[item.uuid]);
    } else {
      tree.push(map[item.uuid]);
    }
  });

  return tree;
};

// --- Utility: Convert to TreeSelect compatible format ---
const convertTreeData = (nodes) =>
  nodes.map((node) => ({
    title: node.name,
    value: node.uuid,
    key: node.uuid,
    children: node.children?.length
      ? convertTreeData(node.children)
      : undefined,
  }));

const RoleForm = (props) => {
  const [form] = Form.useForm();
  const [organizationTree, setOrganizationTree] = useState([]);
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  // --- Fetch organization data ---
  const fetchFirmList = async () => {
    setLoading(true);
    try {
      const res = await fetchOrganization();
      const data = res.data || [];

      if (!Array.isArray(data)) {
        messageApi.open({
          type: "error",
          content: "Invalid organization data format",
        });
        return;
      }

      const treeData = convertTreeData(buildTreeFromData(data));
      setOrganizationTree(treeData);
    } catch (err) {
      messageApi.open({
        type: "error",
        content: "Error fetching organization list",
      });
    } finally {
      setLoading(false);
    }
  };

  // --- Initialize form when editing or loading data ---
  useEffect(() => {
    if (props.editData) {
      form.setFieldsValue({
        roleName: props.editData.roleName,
        active: props.editData.active,
        firm: props.editData.firm
          ? { uuid: props.editData.firm.uuid }
          : undefined,
      });
    } else {
      form.resetFields();
    }
    fetchFirmList();
  }, [props.editData, form]);

  // --- Handle form submission ---
  const handleSubmit = (data) => {
    console.log("data", data);
    props.saveData({ ...props.editData, ...data }).then((success) => {
      if (success) {
        form.resetFields();
      }
    });
  };

  return (
    <Spin spinning={loading}>
      <Form
        form={form}
        layout="horizontal"
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        style={{ maxWidth: 600 }}
        onFinish={handleSubmit}
      >
        {contextHolder}

        {/* Role Name */}
        <Form.Item
          label="Role"
          name="roleName"
          rules={[{ required: true, message: "Please input role name!" }]}
        >
          <Input
            placeholder="Enter role name"
            disabled={props.mode === "view"}
          />
        </Form.Item>

        {/* Organization Selection */}
        <Form.Item
          label="Organization"
          name={["firm", "uuid"]}
          rules={[
            { required: true, message: "Please select an organization!" },
          ]}
        >
          <TreeSelect
            placeholder="Select Organization"
            allowClear
            disabled={props.mode === "view"}
            treeData={organizationTree}
            treeDefaultExpandAll={false}
            showSearch
            value={form.getFieldValue(["firm", "uuid"])}
            onChange={(val) => form.setFieldsValue({ firm: { uuid: val } })}
          />
        </Form.Item>

        {/* Status */}
        <Form.Item label="Status" name="active" valuePropName="checked">
          <Switch
            disabled={props.mode === "view"}
            checkedChildren="Active"
            unCheckedChildren="Inactive"
            defaultChecked
          />
        </Form.Item>

        {/* Submit Button */}
        <Flex justify="end">
          <Button
            type="primary"
            htmlType="submit"
            disabled={props.mode === "view"}
          >
            Submit
          </Button>
        </Flex>
      </Form>
    </Spin>
  );
};

export default RoleForm;
